export default "__VITE_ASSET__sqFEIWXr__"